import { createFileRoute } from "@tanstack/react-router";
import AdminToolRequests from "@/pages/admin/AdminToolRequests";

export const Route = createFileRoute("/admin/peticiones-herramientas")({ component: AdminToolRequests });
